export function prevent(event) {
    event === null || event === void 0 ? void 0 : event.preventDefault();
    event === null || event === void 0 ? void 0 : event.stopPropagation();
    return true;
}
export function preventKey() {
    var keys = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        keys[_i] = arguments[_i];
    }
    return function (e) {
        if (keys.includes(e.key)) {
            return prevent(e);
        }
    };
}
export function focus(id) {
    var input = document.getElementById(id);
    input && input.focus();
}
export function OnKeyGridHandler(targets, options) {
    if (targets === void 0) { targets = 'button'; }
    if (!options) {
        options = {};
    }
    var customHandle = [];
    if (!options.handle)
        options.handle = ['Home', 'End', 'PageUp', 'PageDown', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'];
    if (options.handlers)
        customHandle.push.apply(customHandle, Object.keys(options.handlers));
    var test = function (element) {
        return element && element['tabIndex'] >= 0 && !element['disabled'];
    };
    var findCurrentItem = function (elements) {
        for (var i = 0; i < elements.length; i++) {
            if (document.activeElement === elements[i]) {
                return { currentIndex: i, currentElement: elements[i] };
            }
        }
        return { currentIndex: -1 };
    };
    var handleHome = function (elements) {
        for (var i = 0; i < elements.length; i++) {
            var element = elements[i];
            if (test(element)) {
                return element.focus();
            }
        }
    };
    var handleEnd = function (elements) {
        for (var i = elements.length; i > 0; i--) {
            var element = elements[i - 1];
            if (test(element)) {
                return element.focus();
            }
        }
    };
    var handlePageUp = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        for (var index = 0; index < 5; index++) {
            var expectedRow = 5 - index;
            if ((currentIndex - expectedRow) >= 0) {
                var element = elements[currentIndex - expectedRow];
                if (test(element)) {
                    return element.focus();
                }
            }
        }
    };
    var handlePageDown = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        for (var index = 0; index < 5; index++) {
            var expectedRow = 5 - index;
            if ((currentIndex + expectedRow) < (elements.length - 1)) {
                var element = elements[currentIndex + expectedRow];
                if (test(element)) {
                    return element.focus();
                }
            }
        }
    };
    function findNextItemRight(elements, currentIndex, currentElement) {
        var currentOffsetTop = currentElement.offsetTop;
        for (var index = currentIndex + 1; index < elements.length; index++) {
            var element = elements[index];
            if (test(element)) {
                if (element.offsetTop === currentOffsetTop) {
                    return element;
                }
            }
        }
    }
    function findNextItemBottom(elements, currentIndex, currentElement) {
        var currentOffsetTop = currentElement.offsetTop;
        var candidates = [];
        var findedOffsetTop = -1;
        for (var index = currentIndex + 1; index < elements.length; index++) {
            var element = elements[index];
            if (test(element)) {
                if ((findedOffsetTop === -1 || findedOffsetTop === element.offsetTop) && element.offsetTop > currentOffsetTop) {
                    findedOffsetTop = element.offsetTop;
                    candidates.push(element);
                }
            }
        }
        var test1 = candidates.find(function (item) { return item.offsetLeft === currentElement.offsetLeft; });
        if (test1)
            return test1;
        var test2 = candidates.find(function (item) { return item.offsetLeft < currentElement.offsetLeft; });
        if (test2)
            return test2;
        return candidates[0];
    }
    function findNextItemLeft(elements, currentIndex, currentElement) {
        var currentOffsetTop = currentElement.offsetTop;
        for (var index = currentIndex - 1; index >= 0; index--) {
            var element = elements[index];
            if (test(element)) {
                if (element.offsetTop === currentOffsetTop) {
                    return element;
                }
            }
        }
    }
    function findNextItemTop(elements, currentIndex, currentElement) {
        var currentOffsetTop = currentElement.offsetTop;
        var candidates = [];
        var findedOffsetTop = -1;
        for (var index = currentIndex - 1; index >= 0; index--) {
            var element = elements[index];
            if (test(element)) {
                if ((findedOffsetTop === -1 || findedOffsetTop === element.offsetTop) && element.offsetTop < currentOffsetTop) {
                    findedOffsetTop = element.offsetTop;
                    candidates.push(element);
                }
            }
        }
        var test1 = candidates.find(function (item) { return item.offsetLeft === currentElement.offsetLeft; });
        if (test1)
            return test1;
        var test2 = candidates.find(function (item) { return item.offsetLeft < currentElement.offsetLeft; });
        if (test2)
            return test2;
        return candidates[0];
    }
    var handleArrowDown = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        var isBottom = findNextItemBottom(elements, currentIndex, currentElement);
        if (isBottom)
            return isBottom.focus();
        var isRight = findNextItemRight(elements, currentIndex, currentElement);
        if (isRight)
            return isRight.focus();
    };
    var handleArrowRight = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        var isRight = findNextItemRight(elements, currentIndex, currentElement);
        if (isRight)
            return isRight.focus();
        var isBottom = findNextItemBottom(elements, currentIndex, currentElement);
        if (isBottom)
            return isBottom.focus();
    };
    var handleArrowLeft = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        var isLeft = findNextItemLeft(elements, currentIndex, currentElement);
        if (isLeft)
            return isLeft.focus();
        var isTop = findNextItemTop(elements, currentIndex, currentElement);
        if (isTop)
            return isTop.focus();
    };
    var handleArrowUp = function (elements) {
        var _a = findCurrentItem(elements), currentIndex = _a.currentIndex, currentElement = _a.currentElement;
        if (!currentElement)
            return;
        var isTop = findNextItemTop(elements, currentIndex, currentElement);
        if (isTop)
            return isTop.focus();
        var isLeft = findNextItemLeft(elements, currentIndex, currentElement);
        if (isLeft)
            return isLeft.focus();
    };
    return function (target, event) {
        if (!target || event.isPropagationStopped() || event.defaultPrevented)
            return;
        var key = event.code;
        var elements = target.querySelectorAll(targets);
        if (customHandle.includes(key) && options.handlers[key]) {
            options.handlers[key](event);
            return;
        }
        else if (options.handle.includes(key) && (!options.omit || !options.omit.includes(key))) {
            if (key === 'Home')
                handleHome(elements);
            else if (key === 'End')
                handleEnd(elements);
            else if (key === 'ArrowUp')
                handleArrowUp(elements);
            else if (key === 'ArrowDown')
                handleArrowDown(elements);
            else if (key === 'PageUp')
                handlePageUp(elements);
            else if (key === 'PageDown')
                handlePageDown(elements);
            else if (key === 'ArrowLeft')
                handleArrowLeft(elements);
            else if (key === 'ArrowRight')
                handleArrowRight(elements);
        }
        else {
            if (typeof options.forceFocus === 'string') {
                var force = document.getElementById(options.forceFocus);
                force && force.focus();
                return;
            }
            else if (options.forceFocus) {
                options.forceFocus.focus();
                return;
            }
        }
    };
}
export function InputListFocusHandler(items, currentFocusedIndex, tablePrefix, cb) {
    return function (target, event) {
        if (!target || event.isPropagationStopped() || event.defaultPrevented)
            return;
        var key = event.code;
        var newFocusedIndex = -1;
        if (items && items.length > 0) {
            if (key === 'Enter' && currentFocusedIndex >= 0) {
                newFocusedIndex = currentFocusedIndex;
            }
            else if (key === 'ArrowDown') {
                if (currentFocusedIndex < items.length - 1)
                    newFocusedIndex = currentFocusedIndex + 1;
            }
            else if (key === 'ArrowUp') {
                if (currentFocusedIndex > 0)
                    newFocusedIndex = currentFocusedIndex - 1;
            }
            else if (key === 'Home') {
                newFocusedIndex = 0;
            }
            else if (key === 'End') {
                newFocusedIndex = items.length - 1;
            }
            else if (key === 'PageUp') {
                for (var index = 0; index < 5; index++) {
                    var expectedRow = 5 - index;
                    if ((currentFocusedIndex - expectedRow) >= 0) {
                        newFocusedIndex = currentFocusedIndex - expectedRow;
                        break;
                    }
                }
            }
            else if (key === 'PageDown') {
                for (var index = 0; index < 5; index++) {
                    var expectedRow = 5 - index;
                    if ((currentFocusedIndex + expectedRow) < items.length) {
                        newFocusedIndex = currentFocusedIndex + expectedRow;
                        break;
                    }
                }
            }
        }
        if (newFocusedIndex >= 0) {
            cb(newFocusedIndex);
            if (typeof tablePrefix === 'string') {
                var targetLi = document.getElementById("".concat(tablePrefix, "-item-").concat(newFocusedIndex));
                targetLi && targetLi.scrollIntoView({ behavior: 'auto', block: 'center' });
                var inputEl = document.getElementById("".concat(tablePrefix, "-input"));
                if (inputEl && document.activeElement !== inputEl) {
                    inputEl.focus();
                }
            }
        }
    };
}
export function NextFocus(selector) {
    function test(element) {
        return element && element['tabIndex'] >= 0 && !element['disabled'];
    }
    ;
    function findCurrentItem(elements) {
        for (var i = 0; i < elements.length; i++) {
            if (document.activeElement === elements[i]) {
                return { currentIndex: i, currentElement: elements[i] };
            }
        }
        return { currentIndex: -1 };
    }
    ;
    var elements = document.querySelectorAll(selector);
    var currentIndex = findCurrentItem(elements).currentIndex;
    for (var index = currentIndex + 1; index < elements.length; index++) {
        var element = elements[index];
        if (test(element)) {
            element.focus();
            break;
        }
    }
}
